import {
  keys,
  mapKeys,
  pickBy,
  capitalize,
  findIndex,
} from 'lodash';

const getWidgetType = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get('widget');
};

const isCrashWidget = (widget) => {
  const crashWidgets = [
    'crashCash',
    'crashCashWeb',
    'pocketRocket',
  ];
  return crashWidgets.includes(widget);
};

// Priority is different depending on a widget type
const getPriorityMap = (isCrash) => ({
  quests: isCrash ? 2 : 1,
  feed: isCrash ? 1 : 2,
  tournaments: 3,
  achievements: 4,
});

const setModulesPriority = (object, priorityMap) => {
  Object.entries(object).forEach(([key, module]) => {
    // eslint-disable-next-line no-param-reassign
    module.priority = priorityMap[key];
  });
};

const sortedModulesPriority = (modules) => Object.entries(modules)
  .sort(([, a], [, b]) => a.priority - b.priority)
  .reduce((acc, [key, value]) => {
    // eslint-disable-next-line no-param-reassign
    acc[key] = value;
    return acc;
  }, {});

const getActiveModules = (sortedModules, mappedModules, config, tenant) => {
  const active = keys(sortedModules);

  const achievementsIdx = active.indexOf('achievements');
  if (achievementsIdx > -1) active.splice(achievementsIdx, 1);

  if (active.includes('quests') && (!mappedModules.quests.show || !tenant.config.questSupport)) {
    const questsIdx = findIndex(active, (module) => module === 'quests');
    if (questsIdx > -1) active.splice(questsIdx, 1);
  }

  return active;
};

const createNavigationState = (activeModules, mappedModules, response) => {
  const currentModule = response.data ? capitalize(activeModules[0]) : 'Error';
  return {
    modules: activeModules,
    action: '',
    title: '',
    animation: '',
    currentModule,
    ...mappedModules,
  };
};

const createBoostState = (response, config) => {
  const { feed = {}, profile = {}, tenant = {} } = response.data || {};
  const betTickets = !(feed?.types?.length === 1 && (feed?.types[0] === 'Win' || feed?.types[0] === 'BetAndWin'));
  const canViewOtherProfiles = (!config.playerId && feed?.privacy?.profileAccess?.guest)
    || (config.playerId && feed?.privacy?.profileAccess?.registered);
  const isRetailIntegration = config.channel === 'Location';

  return {
    betTickets,
    isRetailIntegration,
    canViewOtherProfiles,
    modulesVisibility: config.showOnLoad,
    isMasked: profile?.feed?.isMasked,
    feedColumns: keys(pickBy(feed?.fields)),
    unavailable: !response.data,
    feedSize: isRetailIntegration ? Math.floor((window.innerHeight - 70) / 36) : 100,
    isNicknameAllowed: tenant?.config?.useCustomProfileDisplayName && !profile?.isCustomDisplayNameSet,
    streamIntervalValue: feed?.streamIntervalValue || 500,
    isFeedMasked: !tenant?.config?.useCustomProfileDisplayName && feed?.privacy?.isMasked,
    questsSupported: tenant?.config?.questSupport || false,
  };
};

export default function mapState(response, config) {
  const {
    modules = {},
    tenant = {},
  } = response.data || {};

  const widget = getWidgetType();
  const priorityMap = getPriorityMap(isCrashWidget(widget));
  const mappedModules = mapKeys(pickBy(modules, 'show'), (_, key) => (key === 'profile' ? 'achievements' : key));
  setModulesPriority(mappedModules, priorityMap);
  const sortedModules = sortedModulesPriority(mappedModules);

  if (!config.playerId) delete mappedModules.achievements;
  const activeModules = getActiveModules(sortedModules, mappedModules, config, tenant);

  const navigation = createNavigationState(activeModules, mappedModules, response);
  const boostState = createBoostState(response, config);

  return { navigation, boostState };
}
